import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setupNavigation } from "../../../redux/actions/navItemsActions";
import { closeAccount } from "../../../redux/actions/settingsActions";
import Spinner from "../../common/Spinner";
import { toast } from "react-toastify";
import $ from 'jquery';

function DeleteProfilePage({
    auth,
    user,
    setupNavigation,
    closeAccount,
    settings,
    history,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [problemGroups, setProblemGroups] = useState([]);
    const [processing, setProcessing] = useState(false);

    const navigationItems =
    {
        sections: [
            {
                name: 'Settings',
                showTitle: true,
                items: [
                    {
                        path: '/user/settings/general',
                        text: 'General Settings',
                        icon: 'fas fa-tasks'
                    },
                    {
                        path: '/user/settings/site',
                        text: 'Site Settings',
                        icon: 'fas fa-cogs'
                    },
                    {
                        path: '/user/settings/security',
                        text: 'Security',
                        icon: 'fas fa-key'
                    },
                    {
                        path: '/user/settings/garmin',
                        text: 'Garmin Connect',
                        icon: 'fas fa-mobile-android-alt'
                    },
                    {
                        path: '/user/settings/closeaccount',
                        text: 'Close Account',
                        icon: 'fas fa-user-times'
                    }
                ]
            }
        ]
    };

    useEffect(() => {
        document.title = "Delete Profile | JustGoRide";
        setupNavigation(navigationItems);
        if (!user || !user.id) {
            history.push("/login");
        }
    }, []);

    function onDelete(e) {
        e.preventDefault();
        $("#closeAccount").modal("show"); 
    }

    function onCancelCloseAccount(e) {
        e.preventDefault();
        $("#closeAccount").modal("hide"); 
    }

    function onCloseAccount(e) {
        e.preventDefault();
        setProcessing(true);
        $("#closeAccount").modal("hide");

        closeAccount(user.id)
            .then((result) => {
                if (!result.userDeleted && result.problemGroups.length > 0) {
                    setProblemGroups(result.problemGroups);
                    setProcessing(false);
                }
                else if (result.userDeleted === true) {
                    toast.success("Your account has been removed!")
                    history.push("/logout");
                }
                else {
                    errors.onAccountRemoval = `Account Removal Failed. There has been a problem deleting your data. Please contact admin@justgoride.co.uk.`;
                    setErrors(errors);
                    setProcessing(false);
                }
            })
            .catch(error => {
                errors.onAccountRemoval = `Account Removal Failed. There has been a problem deleting your data. Please contact admin@justgoride.co.uk.`;
                setErrors(errors);
                setProcessing(false);
            });
    }

    return (
        processing ?
            <Spinner /> :
            <div>
                <div className="settings-container row justify-content-md-center pb-5">
                    <form className="col-md-6 mt-md-5">
                        <h2 className="mb-3">Close Account</h2>
                        {errors.onAccountRemoval && (
                            <div className="alert alert-danger" role="alert">
                                {errors.onAccountRemoval}
                            </div>
                        )}
                        {problemGroups.length > 0 && (
                            <div className="alert alert-warning" role="alert">
                                <h4>Removal Failed</h4>
                                <p>You are the sole administrator of the following groups:</p>
                                <ul>
                                    {
                                        problemGroups.map((group, idx) => {
                                            return (
                                                <li key={idx}>{group}</li>
                                            );
                                    })}
                                </ul>
                                <p>Please delegate administrative rights to another group member before closing your account.</p>
                            </div>
                        )}
                        <p>
                            If you no longer want to be a member of the JustGoRide riding community you can close your account here.
                            By opting to close your account all of your data will be erased. This will include your routes, rider network,
                            group membership and all related posts, comments, and reactions. 
                        </p>
                        <p className="alert alert-danger" >
                            All data is permanently erased and the process cannot be reversed. Please ensure that you really want to
                            close your account before continuing! 
                        </p>

                        <h4>Group Administration</h4>
                        <p>
                            Groups are not deleted as part of the account removal process. If you are the sole administrator in a group with
                            members then you will need to delegate administative rights to another member before you can close your account.
                            This can be done on the relevant group page through the members tab. 
                        </p>

                        <button type="submit" onClick={onDelete} disabled={processing} className="btn btn-danger float-right mt-4">
                            {processing ? "Processing..." : "Delete Your User Profile"}
                        </button>
                    </form>
                </div>
                <div className="modal fade" id={"closeAccount"} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" >Confirm Account Closure Request?</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Are you sure that you want to delete all of your user data and close your account?
                                    </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onCancelCloseAccount}>No</button>
                                <button type="button" className="btn btn-primary" onClick={onCloseAccount}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );

}



DeleteProfilePage.propTypes =
{
    setupNavigation: PropTypes.func.isRequired,
    closeAccount: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        settings: state.settings,
        auth: state.auth,
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation,
    closeAccount
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProfilePage);




// WEBPACK FOOTER //
// ./src/components/user/settings/DeleteProfilePage.js